// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 639 ? "fe6c8909" : chunkId) + "." + {"369":"00564b46b452984f","639":"c01d6a180591a1a7"}[chunkId] + ".js";
};